/**
 * Immersive Themes Page
 * 
 * Página de administração para configuração de temas imersivos.
 * Permite visualizar, testar e aplicar temas que afetam todos os componentes.
 */

import { ImmersiveThemeGallery } from '../../components/theming/ImmersiveThemeGallery';

export function ImmersiveThemes() {
  return (
    <div className="p-6">
      <ImmersiveThemeGallery />
    </div>
  );
}

export default ImmersiveThemes;
